import React from 'react';
import { Card, Text, Group, Stack } from '@mantine/core';

export const TestimonialCard: React.FC<{ t: any; idx: number; }> = ({ t, idx }) => {
    const key = `testimonials.${idx}`;
    return (
        <Card shadow="md" padding="md" mb="md" withBorder>
            <Text className='testimonial-maintxt' dangerouslySetInnerHTML={{ __html: t(`${key}.message`) }} />
            <Group mt="md">
                {/* Image section commented out as in original */}
                <Stack gap={0}>
                    <Text fw={500}>{t(`${key}.author`)}</Text>
                    <Text size="sm" c="dimmed">{t(`${key}.title`)}</Text>
                </Stack>
            </Group>
        </Card>
    );
};
